import React, { useRef } from 'react';
import useAttractionPhoto from '../hooks/useAttractionPhoto';

export const ArticlePhoto = ({ keyword, destination, style }) => {
  // Stable random idx — never regenerated on re-render to prevent photo jumping
  const idxRef = useRef(Math.floor(Math.random() * 10));
  const photo = useAttractionPhoto(keyword, 'culture', idxRef.current, destination);
  return (
    <img src={photo} alt={keyword} loading="lazy"
      style={{ width:'100%', height:'100%', objectFit:'cover', ...style }}
      onError={e => e.target.style.display = 'none'}/>
  );
};

export const IntelAttractionCard = ({ name, city, desc, tip, category, index, nameEn = '' }) => {
  const photo = useAttractionPhoto(name, category || 'culture', index, city, true, nameEn);
  return (
    <div style={{ borderRadius:14, overflow:'hidden', background:'#fff', border:'1px solid #e2e8f0', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
      <div style={{ height:140, overflow:'hidden', background:'#f1f5f9', position:'relative' }}>
        <img src={photo} alt={name} loading="lazy"
          style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }}
          onError={e => { e.target.style.display = 'none'; }}/>
      </div>
      <div style={{ padding:'12px' }}>
        <p style={{ margin:'0 0 5px', fontSize:13, fontWeight:800, color:'#0f172a' }}>{name}</p>
        <p style={{ margin:'0 0 6px', fontSize:12, color:'#64748b', lineHeight:1.6 }}>{desc}</p>
        {tip && <p style={{ margin:0, fontSize:11, color:'#f59e0b', fontWeight:700 }}>💡 {tip}</p>}
      </div>
    </div>
  );
};

export default ArticlePhoto;
